<template>
	<g>
		<!-- <path :d="d" class="grid"></path> -->
		<TracePoint v-for="attack in attackers" :key="attack.id" :pos="attack.pos" :opacity="attack.opacity" :symbol="d3.symbolTriangle" color="#ff0000" />
		<TracePoint v-for="target in targets" :key="target.id" :pos="target.pos" :opacity="target.opacity" :symbol="d3.symbolCircle" color="#00ff00"/>
		<g id="labels">
			<MapLabel v-for="label in labels" :key="label.id" :pos="label.pos" :country="label.country" :subdivision="label.subdivision" :city="label.city" :hidden='label.hidden' />
		</g>
	</g>
</template>

<script>
	import _ from "lodash";
	import * as d3 from "d3";

	import TracePoint from './TracePoint.vue'
	import MapLabel from '../map/MapLabel.vue'

	export default {
		name: "HexbinGrid",
		components: {
			TracePoint,
			MapLabel,
		},
		props: {
			mapping: {},
			traces: {},
			recentTraces: {},
		},
		data: function(){
			return {
				d3: d3,
			};
		},
		computed: {
			d: function () {
				return this.mapping.hexbin.mesh();
			},
			attackers: function() {
				let hexdata = this.mapping.hexbin(_.map(this.traces, (trace) => {
					return trace.nodes[0].pos;
				}));
				return this.hexdataToPoints(hexdata);
			},
			targets: function () {
				let hexdata = this.mapping.hexbin(_.map(this.traces, (trace) => {
					return trace.nodes[trace.nodes.length - 1].pos;
				}));
				return this.hexdataToPoints(hexdata);
			},
			labels: function () {
				return _.chain(this.recentTraces).flatMap((trace) => {
					return [
						trace.nodes[0],
						trace.nodes[trace.nodes.length-1],
					];
				})
				.reverse()
				.map((node, i, nodes) => {
					return {
						hidden: !!nodes.slice(0, i).find(existing => {
							return (
								Math.abs(node.x - existing.x) < 65 &&
								Math.abs(node.y - existing.y) < 30
							);
						}),
						...node
					};
				})
				.value();
			},
		},
		methods: {
			hexdataToPoints: function(hexdata) {
				let maxLengthPoint = _.maxBy(hexdata, (point) => point.length);
				if (!maxLengthPoint || maxLengthPoint === 1) {
					maxLengthPoint = {length: 2};
				}
				let scaleOpacity = d3.scaleLinear()
					.domain([1, maxLengthPoint.length])
					.range([0.5, 1])
				;
				return _.map(hexdata, (point) => {
					return {
						id: point[0].id,
						pos: [point.x, point.y],
						opacity: scaleOpacity(point.length),
					};
				});
			},
		}
	}
</script>

<style scoped>
	path {
		stroke: #dddddd;
		stroke-width: 1;
		/*stroke-linecap: round;*/
		fill: none;
	}
</style>